module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_vm._t("default", [_c('p', {
    staticClass: "table-cell-name"
  }, [_vm._v(_vm._s(_vm.cellData.label || _vm.cellData.name))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70f3a8be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/table/TableCell.vue
// module id = 114
// module chunks = 2